import React, { FC, useState } from "react";
import { ForetakMedLenker } from "../infrastructure/api/api";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import { Input } from "@digipost/dds-input-react";
import styles from "./ManuellFindOrgnr.module.less";
import { useTranslate } from "../infrastructure/translation/useTranslate";
import { PrimaryButton, SecondaryButton } from "@digipost/dds-buttons-react";
import { useNavigate } from "react-router";
import { Banner } from "@digipost/dds-banner-react";
import { orgNrValidator } from "../infrastructure/validation/validation";
import { removeWhitespace } from "../infrastructure/stringutils/stringutils";
import { usePreselectedOrgnr } from "../PartnerOnboarding/usePreselectedOrgnr";
import { useFinnRegistrertbartFraVerv } from "../Registreringsflyt/useFinnRegistrertbartFraVerv";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { Route } from "../infrastructure/routing/routes";

export const ManuellFinnOrgnr: FC<{
  velgForetak: (foretak: ForetakMedLenker) => void;
  goBack: () => void;
  showBecauseNoResults: boolean;
}> = ({ velgForetak, goBack, showBecauseNoResults }): React.ReactElement => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const preselectedOrgnr = usePreselectedOrgnr();

  const [orgNr, setOrgNr] = useState<string>("");
  const [orgNrValid, setOrgNrValid] = useState<boolean>(true);

  const [showSubmitError, setShowSubmitError] = useState<boolean>(false);

  const { finnRegistrerbartFraVerv } = useFinnRegistrertbartFraVerv();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setShowSubmitError(false);

    if (!orgNrValidator(orgNr)) {
      setOrgNrValid(false);
      return;
    } else {
      setOrgNrValid(true);
    }
    await searchWithOrgnr(orgNr);
  };

  const searchWithOrgnr = async (orgNr: string) => {
    finnRegistrerbartFraVerv(orgNr)
      .then((foretak) => {
        if (foretak) {
          velgForetak(foretak);
        } else {
          navigate(`../../${Route.Manuell}/kontaktinfo?orgNr=${orgNr}`);
        }
      })
      .catch((error) => {
        setShowSubmitError(true);
        throw error;
      });
  };

  if (preselectedOrgnr) {
    void searchWithOrgnr(preselectedOrgnr);
    return <LoadingPage />;
  }

  return (
    <section className={styles.wrapper}>
      <Heading level={1} size={"large"}>
        <Translated textKey={"manual.find_orgnr"} />
      </Heading>
      {showSubmitError && (
        <Banner variant={"warning"} role={"alert"}>
          <Translated textKey={"generic.error"} />
        </Banner>
      )}
      {showBecauseNoResults && (
        <Translated allowHtml textKey={"manual.no_results_body"} />
      )}
      <form>
        <fieldset className={styles.manualSearch}>
          <Input
            name={"orgnr"}
            inputType={"text"}
            labelText={translate("generic.orgnr")}
            value={orgNr}
            valid={orgNrValid}
            errorText={orgNrValid ? "" : translate("validation.orgnr")}
            onChange={(e) => setOrgNr(removeWhitespace(e.target.value))}
          />
          <PrimaryButton onClick={handleSubmit}>
            <Translated textKey={"generic.search"} />
          </PrimaryButton>
        </fieldset>
      </form>
      {!showBecauseNoResults && (
        <SecondaryButton onClick={goBack} type={"button"}>
          <Translated textKey={"generic.back"} />
        </SecondaryButton>
      )}
    </section>
  );
};
